<template lang="html">
  <div>
    <md-layout md-gutter="16">

      <md-layout md-flex="70" md-flex-medium="100" md-flex-small="100" md-flex-xsmall="100" v-if="ready">      
        <md-stepper @completed="finalizar">
           <md-step md-label="Forma de envio"  md-button-back="Atras" md-button-continue="Continuar">
            <p><b> Selecciona la forma de envio:</b></p>
            <md-layout md-gutter="16">
              <md-layout md-flex="25" md-flex-small="100" md-flex-xsmall="100" class="whiteframe" v-if="parametros.envio === 'domicilio' || parametros.envio === 'ambos' ">
                <md-radio v-model="isEnvio" 
                    :id="index" 
                    name="my-test-group1" 
                    md-value="true">
                    Envio a Domicilio
                </md-radio>
              </md-layout>
              <md-layout md-flex="25" md-flex-small="100" md-flex-xsmall="100" class="whiteframe" v-if="parametros.envio === 'tienda' || parametros.envio === 'ambos' ">
                <md-radio v-model="isEnvio" 
                    :id="index" 
                    name="my-test-group1" 
                    md-value="false">
                Recoger en tienda
                </md-radio>
              </md-layout>
              
            </md-layout>
          </md-step>
          <md-step  md-label="Opciones de envio" :md-error="!direccionValid" :md-continue="direccionValid" md-button-back="Atras" :md-button-continue="'Continuar'">
            <div>
              <div v-if="isEnvio === true || isEnvio === 'true'">
              <p><b> Selecciona la dirección de envio:</b></p>
              <md-layout md-gutter="16">
                <md-layout md-flex md-flex-small="100" md-flex-xsmall="100" >
                <md-button class="md-accent" @click.native="openModal('DireccionModal')">Agregar nueva direccion</md-button>
                </md-layout>
                <md-layout md-flex="30" md-flex-small="100" md-flex-xsmall="100" class="whiteframe" v-for="(direccion, index) in direcciones" :ref="index" :key="index">
                  <md-radio v-model="idDireccion" 
                  :id="index" 
                  name="my-test-group1" 
                  :md-value="direccion.idInterno">
                  </md-radio>
                  <div style="margin-left:10px;">
                    <b>{{direccion.Recibe}}</b> <br/>
                    {{direccion.direccion}}, {{direccion.NumExt}}( {{direccion.NumInt}})<br/>
                    {{direccion.Colonia}}, {{direccion.CP}} <br/>
                    {{direccion.Poblacion}}, {{direccion.EntFed}}, {{direccion.Pais}}<br/>
                    {{direccion.telefono}}
                  </div>
                </md-layout>
              </md-layout>
              </div>
              <!-- <div >
                <md-layout md-gutter="16" v-show="isEnvio === 'false'">
                  <md-layout md-flex="25"  md-align="center" md-flex-small="100" md-flex-xsmall="100" class="whiteframe">
                    <p><b>El envio lo podras recoger en tienda</b></p>
                  </md-layout>
                </md-layout>
              </div> -->
            </div>
            <md-layout>
              <md-layout md-flex="100">
                Agrega una observación a tu pedido:
              </md-layout>
              <md-layout md-flex="100">
                <md-input-container>
                  <label>Observacion</label>
                  <md-input v-model="observacion" maxlength="200"></md-input>
                </md-input-container>
              </md-layout>
              <!-- <md-layout md-flex="100" v-if="!(pagarEnLinea == true || pagarEnLinea == 'true')">
                <label style="font-style:italic">*Al dar click en finalizar está aceptando los <a style="color: rgb(118, 118, 118);" target="_blank" href="https://stshop.club:85/ejemplo2/TERMINOS%20Y%20CONDICIONES.PDF">Terminos y Condiciones</a></label>
              </md-layout> -->
            </md-layout>
          </md-step>
           <!-- <md-step md-label="Costo Envio" :md-disabled="!direccionValid"  md-button-back="Atras" md-button-continue="Continuar">
           <md-layout>
              <md-radio v-model="isEnvio" 
                :id="index" 
                name="my-test-group1" 
                md-value="xCobrar" v-if="v-">
                Envio por cobrar
              </md-radio>
              <md-radio v-model="isEnvio" 
                :id="index" 
                name="my-test-group1" 
                md-value="xCobrar">
                Envio a Domicilio
              </md-radio>
            </md-layout>
          </md-step> -->
          <md-step md-label="Forma de pago" :md-disabled="!direccionValid"  md-button-back="Atras" md-button-continue="Continuar">
            <md-layout md-gutter="16">
              <md-layout md-flex="25" md-flex-small="100" md-flex-xsmall="100" class="whiteframe" v-if="parametros.pago === 'xCobrar' || parametros.pago === 'ambos' ">
                <md-radio v-model="pagarEnLinea" 
                    :id="index" 
                    name="my-test-group1" 
                    md-value="false">
                    Pagar al recoger pedido
                </md-radio>
              </md-layout>
              <md-layout md-flex="30" md-flex-small="100" md-flex-xsmall="100" class="whiteframe" v-if="parametros.pago === 'enLinea' || parametros.pago === 'ambos' ">
                    
                    <img id="mp" src="./mercadopago.png" alt="No se encontro la imagen" />
                <md-radio v-model="pagarEnLinea" 
                    :id="index" 
                    name="my-test-group1" 
                    md-value="true"
                    >
                    Pagar en linea
                </md-radio>
              </md-layout>            
            </md-layout>
            <md-layout md-gutter="16">
              
            </md-layout>
          </md-step>
          <md-step md-label="Pago" :md-disabled="!direccionValid" md-button-back="Atras" 
            :md-button-continue="pagarEnLinea == true ? 'Pagar y Finalizar pedido': 'Finalizar pedido' " :md-continue="direccionValid && aceptaTerminos">
              <!-- **************************** PAGO OPENPAY ************************************* -->
              
              <md-layout md-gutter="16" v-if="pagarEnLinea === 'true' || pagarEnLinea === true" style="max-width:820px; margin-bottom:50px" class="whiteframe">
                <p><b>Seras redirigido a la pagina de mercadoPago para continuar con tu pago</b></p>
              </md-layout>

            <md-layout md-gutter="16" v-else>
              <p><b>Podrás pagar el pedido a su entrega</b></p>
            </md-layout>

            <md-layout>
              <md-checkbox id="my-test1" name="my-test1" v-model="aceptaTerminos">
                <a style="" target="_blank" href="https://imagen.stshop.mx/ARCOS/IMAGEN/TERMINOS%20Y%20CONDICIONES.pdf">
                  Acepto Terminos y condiciones
                </a>
              </md-checkbox>
            </md-layout>
          </md-step>
        </md-stepper>
      </md-layout>
      <md-layout md-flex="25" md-flex-small="100" md-flex-xsmall="100" class="whiteframe" md-column style="margin:0px;">
        <div md-align="start" class="totales">
          <span class="totalLabel">Subtotal: </span> <span class="totalData">{{toMoney(subtotal)}}</span>
        </div>
        <div md-align="start" class="totales">
          <span class="totalLabel">Impuestos: </span> <span class="totalData">{{impuestos == 0 ? '$ 0.00' : toMoney(impuestos)}}</span>
        </div>
        <div md-align="start" class="totales" v-if="parametros.metodo_envio.trim() === 'porcentaje'">
          <span class="totalLabel">Envio: </span> <span v-if="cart.length !== 0" class="totalData">{{envio == 0 ? '$ 0.00' : toMoney(envio)}}</span>
        </div>
        <div md-align="start" class="totales">
          <span class="totalLabel">Total: </span> <span class="totalData">{{toMoney(subtotal + impuestos + envio)}}</span>
        </div>
      </md-layout>


        <md-dialog ref="DireccionModal" id="DireccionModal">
          <md-dialog-title style="padding:0">
            <md-toolbar>
              <div class="md-title">Agregar Direccion de envio</div>
            </md-toolbar>
          </md-dialog-title>
          <md-dialog-content>
            <md-layout md-gutter="16">
                <md-layout md-flex-xlarge="100"
                  md-flex-large="100"
                  md-flex-medium="100"
                  md-flex-small="100"
                  md-flex-xsmall="100">
                  <md-input-container>
                    <label>Nombre de quien recibe</label>
                    <md-input v-model="direccion.Recibe" required></md-input>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex-xlarge="50"
                md-flex-large="50"
                md-flex-medium="50"
                md-flex-small="100"
                md-flex-xsmall="100">
                  <md-input-container>
                    <label>Dirección</label>
                    <md-input v-model="direccion.direccion" required></md-input>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex-xlarge="25"
                  md-flex-large="25"
                  md-flex-medium="25"
                  md-flex-small="50"
                  md-flex-xsmall="50">
                  <md-input-container>
                    <label>Num Exterior</label>
                    <md-input v-model="direccion.NumExt" required></md-input>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex-xlarge="25"
                  md-flex-large="25"
                  md-flex-medium="25"
                  md-flex-small="50"
                  md-flex-xsmall="50">
                  <md-input-container>
                    <label>Num interior</label>
                    <md-input v-model="direccion.NumInt"></md-input>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex-xlarge="50"
                  md-flex-large="50"
                  md-flex-medium="50"
                  md-flex-small="100"
                  md-flex-xsmall="100">
                  <md-input-container>
                    <label>Colonia</label>
                    <md-input v-model="direccion.Colonia" required></md-input>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex-xlarge="50"
                  md-flex-large="50"
                  md-flex-medium="50"
                  md-flex-small="100"
                  md-flex-xsmall="100">
                  <md-input-container>
                    <label>Ciudad</label>
                    <md-input v-model="direccion.Poblacion" required></md-input>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex-xlarge="50"
                  md-flex-large="50"
                  md-flex-medium="50"
                  md-flex-small="100"
                  md-flex-xsmall="100">
                  <md-input-container>
                    <label>Estado</label>
                    <md-input v-model="direccion.EntFed" required></md-input>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex-xlarge="50"
                  md-flex-large="50"
                  md-flex-medium="50"
                  md-flex-small="100"
                  md-flex-xsmall="100">
                  <md-input-container>
                    <label>Codigo Postal</label>
                    <md-input v-model="direccion.CP" required></md-input>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex-xlarge="50"
                  md-flex-large="50"
                  md-flex-medium="50"
                  md-flex-small="100"
                  md-flex-xsmall="100">
                  <md-input-container>
                    <label>Pais</label>
                    <md-input v-model="direccion.Pais" required></md-input>
                  </md-input-container>
                </md-layout>


                <md-layout md-flex-xlarge="50"
                  md-flex-large="50"
                  md-flex-medium="50"
                  md-flex-small="100"
                  md-flex-xsmall="100">
                  <md-input-container>
                    <label>Telefono</label>
                    <md-input v-model="direccion.telefono"></md-input>
                  </md-input-container>
                </md-layout>

              
            </md-layout>
          </md-dialog-content>
          <md-dialog-actions>
                <md-button class="md-accent" id="entrar" @click.native="closeModal('DireccionModal')">Cancelar</md-button>
                <md-button class="md-primary" id="cancelar" @click.native="agregarDireccion">Agregar</md-button>
          </md-dialog-actions>
        </md-dialog>

        <md-dialog ref="TarjetaModal" id="TarjetaModal">
          <md-dialog-title style="padding:0">
            <md-toolbar>
              <div class="md-title">Agregar Tarjeta</div>
            </md-toolbar>
          </md-dialog-title>
          <md-dialog-content>
            <md-layout md-gutter="16">
                
                <md-layout md-flex="100">
                  <md-input-container>
                    <label>Nombre como aparece en la tarjeta</label>
                    <md-input v-model="tarjeta.holder_name" required></md-input>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex="100">
                  <md-input-container>
                    <label>Numero de tarjeta</label>
                    <md-input type="number" v-model="tarjeta.card_number" required min-length="16" max-length="16"></md-input>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex="33">
                  <md-input-container>
                    <label>Mes expiración</label>
                    <md-select name="expiration_month" id="expiration_month" v-model="tarjeta.expiration_month">
                      <md-option value="01">01</md-option>
                      <md-option value="02">02</md-option>
                      <md-option value="03">03</md-option>
                      <md-option value="04">04</md-option>
                      <md-option value="05">05</md-option>
                      <md-option value="06">06</md-option>
                      <md-option value="07">07</md-option>
                      <md-option value="08">08</md-option>
                      <md-option value="09">09</md-option>
                      <md-option value="10">10</md-option>
                      <md-option value="11">11</md-option>
                      <md-option value="12">12</md-option>
                    </md-select>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex="33">
                  <md-input-container>
                    <label>Año Expiración</label>
                    <md-select name="expiration_year" id="expiration_year" v-model="tarjeta.expiration_year">
                      <md-option value="18">18</md-option>
                      <md-option value="19">19</md-option>
                      <md-option value="20">20</md-option>
                      <md-option value="21">21</md-option>
                      <md-option value="22">22</md-option>
                      <md-option value="23">23</md-option>
                      <md-option value="24">24</md-option>
                      <md-option value="25">25</md-option>
                      <md-option value="26">26</md-option>
                      <md-option value="27">27</md-option>
                      <md-option value="28">28</md-option>
                      <md-option value="29">29</md-option>
                      <md-option value="30">30</md-option>
                      <md-option value="31">31</md-option>
                      <md-option value="32">32</md-option>
                      <md-option value="33">33</md-option>
                    </md-select>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex="33">
                  <md-input-container>
                    <label>cvv2</label>
                    <md-input type="password" v-model="tarjeta.cvv2" required max-length="3"></md-input>
                  </md-input-container>
                </md-layout>

              
            </md-layout>
          </md-dialog-content>
          <md-dialog-actions>
                <md-button class="md-accent" id="entrar" @click.native="closeModal('TarjetaModal')">Cancelar</md-button>
                <md-button class="md-primary" id="cancelar" @click.native="agregarTarjeta">Agregar</md-button>
          </md-dialog-actions>
        </md-dialog>
    </md-layout>

  </div>
</template>
<script type="text/javascript">
import { toMoney } from '../../common/functions/helpers';
import Email from '../../common/functions/smtp'
// import OpenPay from '../../common/functions/openpay'

export default {
  name: 'Inicial',
  data() {
    return {
      resourcePedido: this.$api.pedido(this.$resource),
      resourceCliente: this.$api.cliente(this.$resource),
      resourceOpenPay: this.$api.openpay(this.$resource),
      resourceMP: this.$api.mp(this.$resource),
      idPedido: null,
      cliente: {},
      isEnvio: true,
      pagarEnLinea: true,
      pagos: [],
      pedidos: [],
      direcciones: [],
      direccion: {
        direccion: '',
        NumExt: '',
        Colonia: '',
        Poblacion: '',
        Recibe: '',
        CP: '',
      },
      aceptaTerminos: false,
      observacion: '',
      idDireccion: '',
      envioPedido: {
        ID_clientes_direccion_envios: null,
      },
      tarjetas: [],
      tarjeta: {
        card_number: '',
        holder_name: '',
        expiration_year: '',
        expiration_month: '',
        cvv2: '',
      },
      idTarjeta: '',
      cargo: {},
      iva: 1.16,
      isCustomer: false,
      parametros: {},
      ready: false,
      pagos: 1,
      meses: 1
    };
  },
  beforeRouteUpdate(to) {
    this.idPedido = to.params.idPedido;
  },
  computed:{
    direccionValid() {
      if(String(this.idDireccion).length > 0 || this.isEnvio === 'false') {
        return true;
      } else {
        return false;
      }
    },
    subtotal() {
      let total = 0;
      this.cart.forEach((element) => {
        this.iva = element.pIva;
        total += element.precioTotal;
      });
      return total;
    },
    impuestos() {
      let total = 0;
      this.cart.forEach((element) => {
        total += element.impuestos;
      });
      return total;
    },
    envio() {
      debugger
      if (this.isEnvio == 'false') {
        return 0;
      }
      return (this.subtotal * (this.parametros.porcentaje_envio / 100)) * this.iva
    }
  },
  components: {},
  methods: {
    toMoney,
    justNumber(evt) {
      
      var charCode = (evt.which) ? evt.which : event.keyCode
         if (charCode > 31 && (charCode < 48 || charCode > 57))
            return false;

         return true;
    },
    agregarTarjeta() {
      if(!this.tarjeta.card_number && String(this.tarjeta.card_number).length !== 16){
        this.$toast.create('El numero de tarjeta debe contener 16 digitos', 'snack', 3E3);
        return;
      } 
      if(!this.tarjeta.holder_name && !String(this.tarjeta.holder_name).length > 0){
        this.$toast.create('El campo Nombre es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.tarjeta.expiration_year && !String(this.tarjeta.expiration_year).length > 0){
        this.$toast.create('El campo año expiración es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.tarjeta.expiration_month && !String(this.tarjeta.expiration_month).length > 0){
        this.$toast.create('El campo mes expiracion es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.tarjeta.cvv2 && String(this.tarjeta.cvv2).length !== 3){
        this.$toast.create('El campo cvv2 debe contener 3 digitos', 'snack', 3E3);
        return;
      } 
     
      this.saveTarjeta();
    },
    saveCustomer(){
      debugger;
      const cliente = {
        parameters: {
          external_id: this.cliente.cliente.idinterno,
          name: this.cliente.cliente.nombre.trim(),
          last_name: this.cliente.cliente.nombre.trim(),
          email: this.cliente.email ? this.cliente.email.trim() : '',
          requires_account: false,
          phone_number: this.cliente.cliente.telefono ? this.cliente.cliente.telefono.trim() : '',
          address: {
              line1: this.cliente.cliente.direccion ? this.cliente.cliente.direccion.trim(): '  ' + ' ' + this.cliente.cliente.numext ? this.cliente.cliente.numext.trim() : '',
              line2: this.cliente.cliente.colonia ? this.cliente.cliente.colonia.trim() : '  ',
              line3: this.cliente.cliente.ubicacion ? this.cliente.cliente.ubicacion.trim() : '  ',
              state: this.cliente.cliente.entfed ? this.cliente.cliente.entfed.trim() : '  ' ,
              city: this.cliente.cliente.poblacion ? this.cliente.cliente.poblacion.trim() : '  ',
              postal_code: this.cliente.cliente.cp ? this.cliente.cliente.cp.trim() : '  ' ,
              country_code: 'MX'
          }
        }
      }
      cliente.parameters.address.line1 = cliente.parameters.address.line1 === '' ? '    ' : cliente.parameters.address.line1;
      this.resourceOpenPay.guardarCliente(cliente)
        .then((response) => {
          if (response.data.response === 'result'){
            this.saveCargoTarjeta();
            // this.saveCargo3DSecure();
          } else {
            alert(response.data.error.message);
          }
          // this.saveAll();
          // this.deleteAllCart();
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    agregarDireccion() {
      if(!this.direccion.direccion && !this.direccion.direccion.length > 0){
        this.$toast.create('El campo direccion es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.direccion.NumExt && !this.direccion.NumExt.length > 0){
        this.$toast.create('El campo NumExt es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.direccion.Colonia && !this.direccion.Colonia.length > 0){
        this.$toast.create('El campo Colonia es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.direccion.Poblacion && !this.direccion.Poblacion.length > 0){
        this.$toast.create('El campo Poblacion es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.direccion.Recibe && !this.direccion.Recibe.length > 0){
        this.$toast.create('El campo Recibe es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.direccion.CP && !this.direccion.CP.length > 0){
        this.$toast.create('El campo CP es obligatorio', 'snack', 3E3);
        return;
      } 
      if(!this.direccion.Pais && !this.direccion.Pais.length > 0){
        this.$toast.create('El campo Pais es obligatorio', 'snack', 3E3);
        return;
      } 
      this.saveDireccion();
    },
    getDirecciones(){
      const idCliente = this.cliente.cliente.idinterno;
      this.resourceCliente.getDireccion({ idCliente })
          .then((response) => {
            this.direcciones = response.data.data;
            this.ready = true;
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    getPedido(){
      const idPedido = this.idPedido;
      this.resourcePedido.getPedido({ idPedido })
        .then((response) => {
          
          this.pedido = response.data;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    getClienteOpenPay(){
      const idUsuario = this.cliente.cliente.idinterno;
      this.resourceOpenPay.getCliente({ idUsuario })
        .then((response) => {
           
          this.isCustomer = response.data.response === 'result';
          if (this.isCustomer) {
            this.getTarjetas();
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    getTarjetas(){
      const idUsuario = this.cliente.cliente.idinterno;
      this.resourceOpenPay.getTarjetasCliente({ idUsuario })
        .then((response) => {
  
          this.tarjetas = response.data.result;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    saveAll() {
      
      // if(String(this.pagarEnLinea) === 'false') {
        this.savePago();
      // } else {
      //   this.saveCargoTarjeta();
      // }
    },
    saveDireccion() {
      const idCliente = this.cliente.cliente.idinterno;
      this.resourceCliente.postDireccion({ idCliente }, this.direccion)
          .then((response) => {
            this.getDirecciones();
            this.closeModal('DireccionModal');
            this.$toast.create('Direccion creada', 'snack', 3E3);
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    savePago(){
      
      
      let idFormaPago = '';
      const formaPago = this.pagarEnLinea === true || this.pagarEnLinea === 'true' ? '04-TARJETA DE CREDITO' : 'POR COBRAR';
      debugger
      this.pedido.pagos.forEach((element) => {
        if(element.descripcion.trim() === formaPago) {
          idFormaPago = element.idformapago;
        }
      })
      const pago = {
        idformapago: idFormaPago,
        valor: this.pedido.pedido.TOTAL
      };

      this.resourcePedido.pagos({ idPedido: this.idPedido }, pago)
        .then((response) => {
              //this.$toast.create('Pedido Creado', 'snack', 3E3);
              this.deleteAllCart();
              this.$router.push({ name: 'pedidoForm', params: { idPedido: this.idPedido } });
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    saveEnvioDireccion() {
      const ID_clientes_direccion_envios = this.idDireccion;
      this.resourcePedido.postEnviosPedidos({ idPedido: this.idPedido }, { ID_clientes_direccion_envios })
          .then((response) => {
            // this.$toast.create('', 'snack', 3E3);
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    finalizar() {
        this.savePedido();
    },
    getLinkMP(){
        const data = {
          nombre: this.cliente.cliente.nombre,
          email: this.cliente.email,
          descripcion: "Pago pedido" + this.pedido.FOLIO
        }
        this.resourceMP.postCargo({ idPedido: this.idPedido }, data)
          .then((response) => {
            window.open(response.data.initpoint,"_self");
          })
          .catch((err) => {

          })
    },
    validateCardType(){
      OpenPay.card.cardType()
    },
    generateToken() {
      // var _id = 'maxclx0toodpoo2enq1m', _apiKey = "pk_c5a1385205ec4a15986ce00545527675";
      var _id = 'mr6bhgnplipssu4qz7c6', _apiKey = "pk_c62246bfa7434650aaf5eb8d3497b21f";
        var formCard = OpenPay.extractFormInfo($('#processCard'));
        $('#dataCard').text(JSON.stringify(formCard));
        // OpenPay.setSandboxMode(true);
        OpenPay.setSandboxMode(false);
        try {
           
            OpenPay.setId(_id);
            OpenPay.setApiKey(_apiKey);
            OpenPay.token.extractFormAndCreate($('#processCard'), this.successCard, this.errorCard, 'XYMapj0elM');
        } catch (e) {
           
            alert(e);
        }
    },
    
    successCard(response){
      // var content = '', results = document.getElementById('resultDetail');
      // content += 'Id tarjeta: ' + response.data.id+ '<br />';
      // content += 'A nombre de: ' + response.data.holder_name + '<br />';
      // content += 'Marca de tarjeta usada: ' + response.data.brand + '<br />';
      // results.innerHTML = content;
      this.idTarjeta = response.data.id;
      OpenPay.card.cardType(response.data.card.card_number);
      if (this.idPedido === '' || this.idPedido === null) {
        this.saveCargoTarjeta();
      }
       
      this.savePedido();
    },

    errorCard(error){
        // alert('Fallo en la transacción');
        // var content = '', results = document.getElementById('resultDetail');
        // content += 'Estatus del error: ' + response.data.status + '<br />';
        // content += 'Error: ' + response.message + '<br />';
        // content += 'Descripción: ' + response.data.description + '<br />';
        // content += 'ID de la petición: ' + response.data.request_id + '<br />';
        // results.innerHTML = content;
         
        alert('El pago no pudó ser realizado, ' + error.data.description );
    },
    
    saveCargoTarjeta() {  
      const deviceSessionId = OpenPay.deviceData.setup("processCard", "deviceIdHiddenFieldName");
      const idUsuario = this.cliente.cliente.idinterno;
      let cargo = {};
      if(this.pagos > 1){
        cargo = {
          parameters: {
            source_id: this.idTarjeta,
            method: 'card',
            amount: this.pedido.pedido.TOTAL,
            currency: 'MXN',
            description: 'Pago de pedido ' + this.pedido.pedido.FOLIO,
            order_id: this.pedido.pedido.FOLIO,
            device_session_id : deviceSessionId,
            redirect_url: this.parametros.sitio + "/confirmacion/" + this.idPedido,
            use_3d_secure: "true",
            payment_plan: {"payments": this.pagos}
          }
        }
      }else{
        cargo = {
          parameters: {
            source_id: this.idTarjeta,
            method: 'card',
            amount: this.pedido.pedido.TOTAL,
            currency: 'MXN',
            description: 'Pago de pedido ' + this.pedido.pedido.FOLIO,
            order_id: this.pedido.pedido.FOLIO,
            device_session_id : deviceSessionId,
            redirect_url: this.parametros.sitio + "/confirmacion/" + this.idPedido,
            use_3d_secure: "true"
          }
        }
      }      
      
      this.resourceOpenPay.postCargo({ idUsuario, idCard: this.idTarjeta }, cargo)
          .then((response) => {
            debugger
            if (response.data.response === 'result'){
              window.location.href = response.data.result.payment_method.url
              // this.$toast.create('Pago efectuado', 'snack', 3E3);
              // this.saveAll();
              // this.deleteAllCart();
            }
            else {
              window.location.href = this.parametros.sitio + "/confirmacion/" + this.idPedido + "?error=tarjeta"
            }
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    saveCargo3DSecure() {  
      const idUsuario = this.cliente.cliente.idinterno;
      const cargo = {
          source_id: this.idTarjeta,
          method: 'card',
          amount: this.pedido.pedido.TOTAL,
          currency: 'MXN',
          description: 'Pago de pedido ' + this.pedido.pedido.FOLIO,
          order_id: this.pedido.pedido.FOLIO,
          redirect_url: "http://compart.stshop.mx/pagos.html",
          use_3d_secure: "true"
      }
      this.resourceOpenPay.cargo3dSecure({ merchant_id: 'mr6bhgnplipssu4qz7c6'}, cargo)
          .then((response) => {
            this.$toast.create('Pago efectuado', 'snack', 3E3);
            this.saveAll();
            this.deleteAllCart();
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    savePedido() {
      let detalles = [];
      this.cart.forEach((element) => {
        const detalle = {
          idarticulo: element.idinterno,
          cantidad: element.cantidad,
          precio: (element.precio / element.moneda.cotizacion) / element.pIva
        }
        if (element.idsecundaria) {
          detalle.idsecundaria = element.idsecundaria; 
        }
        if (element.id_presentacion) {
          detalle.id_presentacion = element.id_presentacion; 
        }
        detalles.push(detalle);
      });
      if (this.envio !== 0) {
        const envio = {
          idarticulo: this.parametros.articulo_envio,
          cantidad: 1,
          precio: this.envio / this.iva
        }
        detalles.push(envio);
      }
      const pedido = {
        documento: {
          turno: 'M',
          idvendedor: 'STSHOPVEND',
          idcliente: this.cliente.cliente.idinterno,
          detalles: detalles,
          _esBorrador: false,
          IDALMACEN: this.parametros.almacen
        },
        envio: {ID_clientes_direccion_envios: this.idDireccion},
        observacion: this.observacion,
      }
      this.resourcePedido.guardar(pedido)
        .then((response) => {
          this.pedido = response.data;
          this.idPedido = this.pedido.pedido.idinterno;
          this.$toast.create('Pedido Creado', 'snack', 3E3);
          this.deleteAllCart();
          if (this.pagarEnLinea === true || this.pagarEnLinea === 'true') {
            this.getLinkMP();
          } else {
            this.savePago();
          }
          this.enviarMailCliente();
          this.enviarMailVendedor(this.pedido.empresa.email);
          // this.enviarMailVendedor('diegochilomer@hotmail.com');

        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    getPago(){
      this.resourceOpenPay.getMP(folio)
    },
    deleteFromCart(index) {
      this.cart.splice(index, 1);
      window.cart = this.cart;
      localStorage.setItem('cart', JSON.stringify(this.cart));
    },
    deleteAllCart(){
      while(this.cart.length > 0) {
        this.deleteFromCart(0);
      }
    },
     enviarMailCliente(){
      let direccion = '';
      if (this.pedido.direccion) {
        direccion =`${this.pedido.direccion.Recibe} <br/> ${this.pedido.direccion.direccion}, ${this.pedido.direccion.NumExt} ( ${this.pedido.direccion.NumInt})<br/>  ${this.pedido.direccion.Colonia}, ${this.pedido.direccion.CP} <br/> ${this.pedido.direccion.Poblacion}, ${this.pedido.direccion.EntFed}, ${this.pedido.direccion.Pais}<br/> ${this.pedido.direccion.telefono} <br/>`
      } else {
        // direccion = 'El pedido lo podras recoger en tienda.'
        direccion = ''
      }
      let detalles = '';
      this.pedido.detalles.forEach((el) => {
        const detalle = `<tr style='border-bottom:1px solid #acb7c0'> <td style='width: 110px; padding: 10px'> <img height="90" width="90" style='max-height: 90px; height:90px; max-width:90px; width:90px' src='${this.parametros.ruta_imagen}${el.foto}' alt='No se encontro la imagen' /> </td> <td style='text-align: left; padding: 10px'> <label style='font-size: 18px'>${el.descripcion}</label><br> Precio: ${toMoney(parseFloat(el.precio))} <br> Cantidad: ${Math.round(el.cantidad)} </td><td style='text-align: right; padding: 10px'> <label style='font-size: 18px'>${toMoney(parseFloat(el.precioneto) * el.cantidad)}</label><br> </td></tr>`
        detalles = detalles + detalle
      })
      const mail = `<html><head></head><body><div style='margin-left:auto; margin-right: auto; width:650px;'><table style='width:650px; font-size:14px'><tr><td><img height="90" width="300" style='max-height: 90px; height:90px;max-width:300px ' src='${this.parametros.ruta_imagen}${this.pedido.empresa.foto}'alt='No se encontro la imagen' /></td><td style="text-align: right"><b>${this.pedido.empresa.nombre}</b><br>${this.pedido.empresa.direccion} ${this.pedido.empresa.num_ext} (${this.pedido.empresa.num_int})<br>${this.pedido.empresa.colonia}, ${this.pedido.empresa.cp}<br>${this.pedido.empresa.poblacion}, ${this.pedido.empresa.entfed}, ${this.pedido.empresa.pais}<br></td></tr></table><br><br><table style='width:650px; font-size:22px'><tr><td style='margin-left:auto; margin-right:auto; text-align:center'><b>Gracias por comprar con nosotros</b></td></tr></table><br><table style='width:650px'><tr><td style='margin-left:auto; margin-right:auto'><b>Tu Pedido: ${this.pedido.pedido.FOLIO}</b></td></tr></table><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px; '><tr><td style='text-align: left; padding: 10px'><b>Dirección de envio:</b><br>${direccion}</td><td style='text-align:right; padding: 10px'><table style='font-weight: bold; color: #585858; margin-left: auto'><tr><td colsan='2'><b>Resumen del pedido:</b><br><br></td></tr><tr><td style='width:100px'>SubTotal:</td><td>${toMoney(parseFloat(this.pedido.pedido.subtotal))}</td></tr><tr><td>IVA:</td><td> ${toMoney(parseFloat(this.pedido.pedido.iva))}</td></tr><tr><td>Total</td><td>${toMoney(parseFloat(this.pedido.pedido.TOTAL))}</td></tr></table></td></tr></table><br><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px'><tr><td style='text-align: left; padding: 10px'>Observacion:</td></tr><tr><td style='text-align: left; padding: 10px'>${this.observacion}</td></tr></table><br><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px'>${detalles}</table><br><br><div style="width:650px;font-size:14px; font-style: oblique; text-align: right">Este pedido fue creado con STShop (<a href="http://www.superticket.mx">superticket.mx</a>)</div></div></body></html>`
      const data={
        subject: `Pedido ${this.pedido.pedido.FOLIO} STSHOP`,
        for: this.cliente.email,
        mail: mail
      }
      this.resourcePedido.enviarMail(data)
        .then((response) => {
          

        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    enviarMailVendedor(email){
      let direccion = '';
      if (this.pedido.direccion) {
        direccion =`${this.pedido.direccion.Recibe} <br/> ${this.pedido.direccion.direccion}, ${this.pedido.direccion.NumExt} ( ${this.pedido.direccion.NumInt})<br/>  ${this.pedido.direccion.Colonia}, ${this.pedido.direccion.CP} <br/> ${this.pedido.direccion.Poblacion}, ${this.pedido.direccion.EntFed}, ${this.pedido.direccion.Pais}<br/> ${this.pedido.direccion.telefono} <br/>`
      } else {
        direccion = 'El pedido se recogerá en tienda.'
      }
      let detalles = '';
      this.pedido.detalles.forEach((el) => {
        const detalle = `<tr style='border-bottom:1px solid #acb7c0'> <td style='width: 110px; padding: 10px'> <img height="90" width="90" style='max-height: 90px; height:90px; max-width:90px; width:90px' src='${this.parametros.ruta_imagen}${el.foto}' alt='No se encontro la imagen' /> </td> <td style='text-align: left; padding: 10px'> <label style='font-size: 18px'>${el.descripcion}</label><br> Precio: ${toMoney(parseFloat(el.precio))} <br> Cantidad: ${Math.round(el.cantidad)} </td><td style='text-align: right; padding: 10px'> <label style='font-size: 18px'>${toMoney(parseFloat(el.precioneto) * el.cantidad)}</label><br> </td></tr>`
        detalles = detalles + detalle
      })
      const mail = `<html><head></head><body><div style='margin-left:auto; margin-right: auto; width:650px;'><table style='width:650px; font-size:18px'><tr><td><img height="90" width="300" style='max-height: 90px; height:90px;max-width:300px' src='${this.parametros.ruta_imagen}${this.pedido.empresa.foto}'alt='No se encontro la imagen' /></td><td style="text-align: right"><b>${this.pedido.empresa.nombre}</b><br>${this.pedido.empresa.direccion} ${this.pedido.empresa.num_ext} (${this.pedido.empresa.num_int})<br>${this.pedido.empresa.colonia}, ${this.pedido.empresa.cp}<br>${this.pedido.empresa.poblacion}, ${this.pedido.empresa.entfed}, ${this.pedido.empresa.pais}</tr></table><br><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px; font-size:22px'><tr><td style='margin-left:auto; margin-right:auto; text-align:center'><b>Haz recibido un Pedido!</b></td></tr></table><table style='width:650px; border:1px solid #acb7c0; border-radius: 10px;'><tr><td style='margin-left:auto; margin-right:auto; padding: 10px'><b>Pedido: ${this.pedido.pedido.FOLIO}</b><br>${this.cliente.cliente.nombre}<br>${this.cliente.RFC}</td><br>${this.cliente.usuario}</td></tr></table><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px; '><tr><td style='text-align: left; padding: 10px'><b>Dirección de envio:</b><br>${direccion}</td><td style='text-align:right; padding: 10px'><table style='font-weight: bold; color: #585858; margin-left: auto'><tr><td colsan='2'><b>Resumen del pedido:</b><br><br></td></tr><tr><td style='width:100px'>SubTotal:</td><td>${toMoney(parseFloat(this.pedido.pedido.subtotal))}</td></tr><tr><td>IVA:</td><td> ${toMoney(parseFloat(this.pedido.pedido.iva))}</td></tr><tr><td>Total</td><td>${toMoney(parseFloat(this.pedido.pedido.TOTAL))}</td></tr></table></td></tr></table><br><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px'><tr><td style='text-align: left; padding: 10px'>Observacion:</td></tr><tr><td style='text-align: left; padding: 10px'>${this.observacion}</td></tr></table><br><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px'>${detalles}</table><br><br></div></body></html>`
      
      const data={
        subject: `Pedido ${this.pedido.pedido.FOLIO} STSHOP`,
        for: email,
        mail: mail
      }
      this.resourcePedido.enviarMail(data)
        .then((response) => {
          

        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
  },
  mounted() {
    this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
    this.parametros = localStorage.getItem('parametros') ? JSON.parse(localStorage.getItem('parametros')) : {};  
    this.isEnvio =  this.parametros.envio === 'ambos' || this.parametros.envio === 'domicilio' ? 'true' : 'false';
    this.meses =  this.parametros.pagos_meses;
    this.pagarEnLinea =  this.parametros.pago === 'ambos' || this.parametros.pago === 'enLinea' ? 'true' : 'false';
    this.idPedido = this.$route.params.idPedido;
    this.cart = window.cart;
    this.getDirecciones();
    if (this.pagarEnLinea === 'true' || this.pagarEnLinea === true ){
      this.getClienteOpenPay();
    } else {
      this.ready = true;
    }
  },
};
</script>

<style lang="scss">
  #DireccionModal,#TarjetaModal{
    .md-dialog{
      width:700px;
    }
  }
   #openpayCtnr * {
    color: #444;
    font-family: Lato;
    font-size: 16px;
    font-weight: 300;
  }

  #openpayCtnr ::-webkit-input-placeholder {
    font-style: italic;
  }

  #openpayCtnr :-moz-placeholder {
    font-style: italic;
  }

  #openpayCtnr ::-moz-placeholder {
    font-style: italic;
  }

  #openpayCtnr :-ms-input-placeholder {
    font-style: italic;
  }

  #openpayCtnr strong {
    font-weight: 700;
  }

  #openpayCtnr a {
    cursor: pointer;
    display: block;
    text-decoration: none;
  }

  #openpayCtnr a.button {
    border-radius: 5px 5px 5px 5px;
    -webkit-border-radius: 5px 5px 5px 5px;
    -moz-border-radius: 5px 5px 5px 5px;
    text-align: center;
    font-size: 21px;
    font-weight: 400;
    padding: 12px 0;
    width: 100%;
    display: table;
    background: #E51F04;
    background: -moz-linear-gradient(top, #E51F04 0%, #A60000 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #E51F04), color-stop(100%, #A60000));
    background: -webkit-linear-gradient(top, #E51F04 0%, #A60000 100%);
    background: -o-linear-gradient(top, #E51F04 0%, #A60000 100%);
    background: -ms-linear-gradient(top, #E51F04 0%, #A60000 100%);
    background: linear-gradient(top, #E51F04 0%, #A60000 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#E51F04', endColorstr='#A60000', GradientType=0);
  }

  #openpayCtnr a.button i {
    margin-right: 10px;
  }

  #openpayCtnr a.button.disabled {
    background: none repeat scroll 0 0 #ccc;
    cursor: default;
  }

  #openpayCtnr .bkng-tb-cntnt {
    float: left;
    width: 800px;
  }

  #openpayCtnr .bkng-tb-cntnt a.button {
    color: #fff;
    float: right;
    font-size: 18px;
    padding: 5px 20px;
    width: auto;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.o {
    background: none repeat scroll 0 0 rgba(0, 0, 0, 0);
    color: #e51f04;
    border: 1px solid #e51f04;
  }

  #openpayCtnr .bkng-tb-cntnt a.button i {
    color: #fff;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.o i {
    color: #e51f04;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.right i {
    float: right;
    margin: 2px 0 0 10px;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.left {
    float: left;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.disabled.o {
    border-color: #ccc;
    color: #ccc;
  }

  #openpayCtnr .bkng-tb-cntnt a.button.disabled.o i {
    color: #ccc;
  }

  #openpayCtnr .pymnts {
    float: left;
    width: 800px;
  }

  #openpayCtnr .pymnts * {
    float: left;
  }

  #openpayCtnr .sctn-row {
    margin-bottom: 35px;
    width: 800px;
  }

  #openpayCtnr .sctn-col {
    width: 375px;
  }

  #openpayCtnr .sctn-col.l {
    width: 425px;
  }

  #openpayCtnr .sctn-col input {
    border: 1px solid #ccc;
    font-size: 18px;
    line-height: 24px;
    padding: 10px 12px;
    width: 333px;
  }

  #openpayCtnr .sctn-col label {
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 10px;
    width: 100%;
  }

  #openpayCtnr .sctn-col.x3 {
    width: 300px;
  }

  #openpayCtnr .sctn-col.x3.last {
    width: 200px;
  }

  #openpayCtnr .sctn-col.x3 input {
    width: 210px;
  }

  #openpayCtnr .sctn-col.x3 a {
    float: right;
  }

  #openpayCtnr .pymnts-sctn {
    width: 800px;
  }

  #openpayCtnr .pymnt-itm {
    margin: 0 0 3px;
    width: 800px;
  }

  #openpayCtnr .pymnt-itm h2 {
    background-color: #e9e9e9;
    font-size: 24px;
    line-height: 24px;
    margin: 0;
    padding: 28px 0 28px 20px;
    width: 780px;
  }

  #openpayCtnr .pymnt-itm.active h2 {
    background-color: #e51f04;
    color: #fff;
    cursor: default;
  }

  #openpayCtnr .pymnt-itm div.pymnt-cntnt {
    display: none;
  }

  #openpayCtnr .pymnt-itm.active div.pymnt-cntnt {
    background-color: #f7f7f7;
    display: block;
    padding: 0 0 30px;
    width: 100%;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row {
    margin: 20px 30px 0;
    width: 740px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col {
    width: 345px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.l {
    width: 395px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col input {
    width: 303px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.half {
    width: 155px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.half.l {
    float: left;
    width: 190px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.half input {
    width: 113px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.cvv {
    background-image: url("./cvv.png");
    background-position: 156px center;
    background-repeat: no-repeat;
    padding-bottom: 30px;
  }

  #openpayCtnr .pymnt-cntnt div.sctn-row div.sctn-col.cvv div.sctn-col.half input {
    width: 110px;
  }

  #openpayCtnr .openpay {
    float: right;
    height: 60px;
    margin: 10px 30px 0 0;
    width: 435px;
  }

  #openpayCtnr .openpay div.logo {
    background-image: url("./openpay.png");
    background-position: left bottom;
    background-repeat: no-repeat;
    border-right: 1px solid #ccc;
    font-size: 12px;
    font-weight: 400;
    height: 50px;
    padding: 0px 20px 0 0;
  }

  #openpayCtnr .openpay div.shield {
    background-image: url("./security.png");
    background-position: left bottom;
    background-repeat: no-repeat;
    font-size: 12px;
    font-weight: 400;
    margin-left: 20px;
    padding: 20px 0 0 40px;
    width: 200px;
  }

  #openpayCtnr .card-expl {
    float: left;
    height: 80px;
    margin: 20px 0;
    width: 800px;
  }

  #openpayCtnr .card-expl div {
    background-position: left 45px;
    background-repeat: no-repeat;
    height: 70px;
    padding-top: 10px;
  }

  #openpayCtnr .card-expl div.debit {
    background-image: url("./cards2.png");
    margin-left: 20px;
    width: 540px;
  }

  #openpayCtnr .card-expl div.credit {
    background-image: url("./cards1.png");
    border-right: 1px solid #ccc;
    margin-left: 30px;
    width: 209px;
  }

  #openpayCtnr .card-expl h4 {
    font-weight: 400;
    margin: 0;
  }
  .line-right{
    border-right:1px solid #ccc !important;
}

.cartItems {
  .md-list-item-container{
    padding-bottom: 10px;
  }
}

.cartImage {
  max-height: 90px;
}
.cartDetails{
  margin-right:5px;
}
.cartTotal{
  font-size:20px;
  opacity: .8;
  margin-left: 5px;
}
.prices {
  text-align: right;
  padding-right: 10px;
  font-size: 20px;
}

.totalLabel{
  font-size: 30px;
  opacity: .7;
  margin-right:5px;
}

.totalData{
  font-size: 30px;
  font-weight: bold;
  opacity: .7;
}

.totales{
  padding:10px;
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/spa/pagos/Pagos.vue